import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ObservableManager } from '../../types/observableManager.type';

@Directive({
  /*eslint-disable-next-line @angular-eslint/directive-selector*/
  selector: '[muCheckHour]',
})
export class MuCheckHourDirective implements OnInit, OnDestroy {
  @Input('muCheckHour') parentFormControlName!: string;
  @Input() formControlName!: string;
  private observableManager = new ObservableManager();

  constructor(private controlContainer: ControlContainer) {
    /** */
  }

  ngOnInit(): void {
    const parentControl: AbstractControl = this.controlContainer.control.get(this.parentFormControlName);
    const currentControl: AbstractControl = this.controlContainer.control.get(this.formControlName);
    this.observableManager
      .watch(parentControl.valueChanges)
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.validateCurrentControl(currentControl, parentControl);
      });
    this.observableManager
      .watch(currentControl.valueChanges)
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.validateCurrentControl(currentControl, parentControl);
      });
  }

  ngOnDestroy(): void {
    /** */
  }

  /**
   * valudate currento control
   * @param {AbstractControl} currentControl
   * @param {AbstractControl} parentControl
   */
  validateCurrentControl(currentControl: AbstractControl, parentControl: AbstractControl): void {
    const parentDate = new Date(parentControl.value);
    const currentDate = new Date(currentControl.value);
    if (currentDate.getHours() === 0) {
      currentDate.setHours(23);
      currentDate.setMinutes(59);
      currentControl.setValue(currentDate, { emitEevent: false });
    } else if (
      currentDate.getHours() < parentDate.getHours() ||
      (currentDate.getHours() <= parentDate.getHours() && currentDate.getMinutes() <= parentDate.getMinutes())
    ) {
      currentDate.setHours(parentDate.getHours());
      currentDate.setMinutes(parentDate.getMinutes() + 1);
      currentControl.setValue(currentDate, { emitEevent: false });
    }
  }
}
